module.exports = __webpack_public_path__ + "8dc373acb6090373bddebc1ad03cb305.ttf";